/**
 * Shared status colour/label maps — single source of truth.
 * State identifiers: lowercase with spaces (e.g. 'in lavorazione', 'completata')
 *
 * Color values:
 * - Ant Design named colors (e.g. 'gold', 'blue', 'green') for use in <Tag color={...}>
 * - Hex values for use in valueStyle={{ color: ... }} (Ant Design Statistic, etc.)
 */


export const WORK_ORDER_STATUS_COLORS: Record<string, string> = {
  bozza: 'default',
  'in approvazione': 'gold',
  approvata: 'blue',
  'in lavorazione': 'orange',
  completata: 'green',
  sospesa: 'red',
}

export const INTERVENTION_TYPE_COLORS: Record<string, string> = {
  Meccanico: 'blue',
  Carrozziere: 'orange',
}

// ── Work Order status labels (display text) ──────────────────────────────────

export const WORK_ORDER_STATUS_LABELS: Record<string, string> = {
  bozza:             'Bozza',
  'in approvazione': 'In Approvazione',
  approvata:         'Approvata',
  'in lavorazione':  'In Lavorazione',
  completata:        'Completata',
  sospesa:           'Sospesa',
  annullata:         'Annullata',
}

// ── Scheda Lavoro status (Ant Design Tag color names) ────────────────────────

export const SCHEDA_LAVORO_STATUS_COLORS: Record<string, string> = {
  accettazione:      'blue',
  'in analisi':      'orange',
  'in approvazione': 'purple',
  approvata:         'green',
  'in lavorazione':  'cyan',
  completata:        'success',
  riconsegnata:      'default',
  sospesa:           'red',
  annullata:         'red',
}

export const SCHEDA_LAVORO_STATUS_LABELS: Record<string, string> = {
  accettazione:      'Accettazione',
  'in analisi':      'In Analisi',
  'in approvazione': 'In Approvazione',
  approvata:         'Approvata',
  'in lavorazione':  'In Lavorazione',
  completata:        'Completata',
  riconsegnata:      'Riconsegnata',
  sospesa:           'Sospesa',
  annullata:         'Annullata',
}

// Ordine delle 7 fasi principali V2 (sospesa è trasversale)
export const SCHEDA_LAVORO_PHASE_ORDER: Record<string, number> = {
  accettazione:      1,
  'in analisi':      2,
  'in approvazione': 3,
  approvata:         4,
  'in lavorazione':  5,
  completata:        6,
  riconsegnata:      7,
}

// ── Intervention status hex colors (for Statistic valueStyle) ────────────────

export const INTERVENTION_STATUS_HEX: Record<string, string> = {
  preso_in_carico:   '#1890ff',
  attesa_componente: '#faad14',
  sospeso:           '#ff4d4f',
  concluso:          '#52c41a',
}
